import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Japanese%20anime%20romance%20scene%20with%20soft%20warm%20sunset%20lighting%2C%20two%20girls%20and%20one%20boy%20in%20school%20uniforms%20standing%20on%20hilltop%20overlooking%20city%2C%20cherry%20blossom%20petals%20floating%2C%20warm%20pink%20and%20golden%20gradient%20sky%2C%20dreamy%20anime%20art%20style%2C%20emotional%20romantic%20atmosphere&width=1800&height=900&seq=hero-bg-kissxsis&orientation=landscape"
        alt="亲吻姐姐 - 经典恋爱动漫"
        title="亲吻姐姐经典恋爱动漫官方解析站"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/40"></div>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
        <p className="text-white/80 text-sm md:text-base font-body tracking-widest mb-3 animate-fade-in">
          经典恋爱动漫 · 官方解析站
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight max-w-3xl">
          亲吻姐姐
        </h1>
        <p className="mt-4 md:mt-6 text-white/75 text-sm md:text-lg font-body max-w-2xl leading-relaxed">
          带你全面回顾这部经典作品的感动瞬间与名场面，深度解析剧情、角色与声优阵容
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
          <Link
            to="/category/plot-analysis"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 font-body text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            开始探索
          </Link>
          <Link
            to="/category/iconic-scenes"
            className="px-8 py-3 rounded-full bg-white/15 backdrop-blur-sm text-white font-body text-sm font-medium hover:bg-white/25 transition-colors duration-200 border border-white/20 whitespace-nowrap"
          >
            名场面回顾
          </Link>
        </div>
      </div>
      <style>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in { animation: fade-in 0.8s ease-out forwards; }
      `}</style>
    </section>
  );
}